import { render, staticRenderFns } from "./MainImage.vue?vue&type=template&id=bd6131b2&scoped=true&"
import script from "./MainImage.vue?vue&type=script&lang=ts&"
export * from "./MainImage.vue?vue&type=script&lang=ts&"
import style0 from "./MainImage.vue?vue&type=style&index=0&id=bd6131b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6131b2",
  null
  
)

export default component.exports